<template>
  <Banner
    :show="true"
    :text="$t(`main.searchResult.banner.${experience}Text`)"
    :button-text="$t(`main.searchResult.banner.${experience}ButtonText`)"
    :button-link="$urlBuilder('merch-plans', { keyword: 'listings' })"
    :use-nuxt-link="false"
    :bold-text="$t(`main.searchResult.banner.${experience}BoldText`)"
  />
</template>

<script>
import Banner from './Banner.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    Banner
  },
  computed: {
    ...mapGetters('experience', ['getExperience', 'getDefault']),
    experience() {
      return this.getExperience || this.getDefault;
    }
  }
};
</script>
